module.exports = __webpack_public_path__ + "static/img/1_4_2.5edf1fc6.jpg";